export default __webpack_public_path__ + "static/media/slide2.53c4eaff.png";